import { createFileRoute, Link, redirect } from '@tanstack/react-router'
import { api } from '@/lib/api'
import { Button } from '@/components/ui/button'

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    try {
      // Check if user is authenticated
      await api.auth.getCurrentUser()
      // If we get here, user is authenticated, so redirect to generation page
      throw redirect({
        to: '/generation',
        search: {
          loraId: undefined,
          modelSlug: undefined,
          prompt: undefined,
          width: undefined,
          height: undefined,
          steps: undefined,
          cfgScale: undefined,
          clipSkip: undefined,
          seedMode: undefined,
          seed: undefined,
          loras: undefined,
          workflowVariant: undefined,
        }
      })
    } catch (error) {
      // If redirect was thrown, let it propagate
      if (error instanceof Response && error.status === 302) {
        throw error
      }
      // Otherwise, continue to homepage (user not authenticated)
    }
  },
  component: HomePage,
})

function HomePage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="max-w-md w-full space-y-8 border border-border bg-card/70 p-4">
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-bold tracking-tight text-primary">Art Suite</h1>
          <p className="text-sm uppercase tracking-[0.35em] text-muted-foreground">
            Crafted workflows for generation, upscaling, and beyond
          </p>

          <div className="space-y-2">
            <Button className="w-full" asChild>
              <Link to="/auth/login" search={{ redirect: undefined }}>
                Sign In
              </Link>
            </Button>
            <Button variant="outline" className="w-full" asChild>
              <Link to="/auth/register" search={{}}>
                Create Account
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
